import { ComposedTheme } from '@glu/theming';
import '../themeDefaults';

type TEmptyObject = Record<string, never>;
interface ICols {
  col1: TEmptyObject;
  col2: TEmptyObject;
  col3: TEmptyObject;
  col4: TEmptyObject;
  col5: TEmptyObject;
  col6: TEmptyObject;
  col7: TEmptyObject;
  col8: TEmptyObject;
  col9: TEmptyObject;
  col10: TEmptyObject;
  col11: TEmptyObject;
  col12: TEmptyObject;
}

const emptyCols = {} as ICols;

const getCols = (contentFn: (index: number) => { width?: string }) =>
  [...Array(12)].reduce<ICols>(
    (memo, _, index) => ({
      ...memo,
      [`col${index + 1}`]: contentFn(index),
    }),
    emptyCols
  );

const cols = getCols(() => ({}));

const mediaCols = getCols((index: number) => ({
  width: `calc(${(100 / 12) * (index + 1)}%)`,
}));

const styles = ({ layout: { breakpoint } }: ComposedTheme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },

  col: {
    width: '100%',
    boxSizing: 'border-box',
  },
  ...cols,
  // eslint-disable-next-line no-restricted-globals
  [`@media (min-width: ${breakpoint}${isNaN(breakpoint) ? '' : 'px'})`]: mediaCols,
});

export default styles;
